// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__362sW","question":"styles_question__3KIHy","description":"styles_description__3NXtF"};